import { EnvConfigService } from './services/env-config.service';
import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Axalta-Ui';

  showHead: boolean = false;



 

 

  constructor(private router: Router, public envConfigService: EnvConfigService) {
  }


  ngOnInit() {
    
  }

  getUrl(){
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/') {
          this.showHead = false;
        } else {
          // console.log("NU")
          this.showHead = true;
         
        }
      }
    });

  }
}
